import { Component } from 'react'
import * as React from 'react'
import { AnyAction } from 'redux'
import { connect } from 'react-redux'
import { RootState } from '../../core/reducers'
import { ThunkDispatch } from 'redux-thunk'
import { withRouter } from 'react-router'
import EditPasswordForm from './editPasswordForm'
import { 
    actionChangePassword, 
    actionSendCaptcha,
} from '../../core/actions/user'
import './userSetting.css'

interface StateProps {
    
}

interface DispatchProps {
    changePassword(data) : void
    sendCaptcha(data): void
}

class ChangePassword extends Component<StateProps & DispatchProps> {

    constructor(props) {
        super(props);
    }

    handleChangePassword = (data) => {
        this.props.changePassword(data)
    }

    handleSendCaptcha = (data) => {
        this.props.sendCaptcha(data)
    }

    render() {

        return (
            <div className="userSetting model">
                <div className="changePassword">
                    <h3>修改密码</h3>
                    <EditPasswordForm 
                        onCreate={this.handleChangePassword} 
                        sendCaptcha={this.handleSendCaptcha}/>
                </div>
            </div>
        )
    }
}

function mapStateToProps(state: RootState): StateProps {
    return {
        
    }
}

function mapDispatchToProps(dispatch: ThunkDispatch<RootState, null, AnyAction>): DispatchProps {
    return {
        changePassword: (data) => {
            dispatch(actionChangePassword(data))
        },
        sendCaptcha: (data) => {
            dispatch(actionSendCaptcha(data))
        }
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(ChangePassword))